export const generateLogoutUrl = (currentIdToken: string) => {
  return (
    `${import.meta.env.VITE_KEYCLOAK_URL}/realms/${import.meta.env.VITE_KEYCLOAK_REALM}/protocol/openid-connect/logout` +
    `?id_token_hint=${currentIdToken}` +
    `&post_logout_redirect_uri=${encodeURIComponent('efkadashboard://callback/logout')}`
  );
};
